import React from "react";
import QurealSection from "../common/QurealSection";
import SectionHeader from "../components/commons/SectionHeader";
import { ShoppingOutlined } from "@ant-design/icons";

function EComProducts() {
    return (
        <QurealSection
            header={
                <SectionHeader heading="Products" icon={<ShoppingOutlined />} />
            }
        >
            <p>Hello World</p>
            <p>Hello World</p>
            <p>Hello World</p>
            <p>Hello World</p>
            <p>Hello World</p>
            <p>Hello World</p>
        </QurealSection>
    );
}

export default EComProducts;
